export const columnWidthClass = 'w-[2.1875rem]'; // 35px
export const columnWidthInRem = 2.1875;

export const allocationHeightClass = 'h-4'; // 16px
export const allocationHeightInRem = 1;

/**
 * An allocation's 1px ring is drawn outside its body (AllocationWrapper's ::before uses inset -1px),
 * so an allocation occupies 1px more than its body above and below.
 */
export const allocationBorderWidthInRem = 0.0625; // 1px
/** Outer height of one allocation row incl. its ring (1.125rem) — also the height of one create button. */
export const allocationBoxHeightInRem = allocationHeightInRem + 2 * allocationBorderWidthInRem;

export const allocationInnerContainerHeightClass = 'h-2'; // 8px
export const allocationInnerContainerHeightInRem = 0.5;

export const specializationIconSizeClass = 'size-3.5'; // 14px
export const specializationIconSizeInRem = 0.875;

export const insertPhaseButtonIconSizeClass = 'size-3'; // 12px
export const insertPhaseButtonIconSizeInRem = 0.75;

export const insertPhaseBarHeightClass = 'h-[0.5rem]'; // 8px
export const insertPhaseBarHeightInRem = 0.5;

export const editWidgetConnectorHeightClass = 'h-[0.1875rem]'; // 3px
export const editWidgetConnectorHeightInRem = 0.1875;
export const editWidgetConnectorWidthClass = 'w-[0.1875rem]'; // 3px
export const editWidgetConnectorWidthInRem = 0.1875;
export const editWidgetConnectorExtensionsHeightClass = 'h-[0.3125rem]'; // 5px
export const editWidgetConnectorExtensionsHeightInRem = 0.3125;

export const editWidgetIconWrapperSizeClass = 'size-[1.125rem]'; // 18px
export const editWidgetIconWrapperSizeInRem = 1.125;
export const editWidgetIconInnerWrapperSizeClass = 'size-4'; // 16px
export const editWidgetIconInnerWrapperSizeInRem = 1;
export const editWidgetIconSizeClass = 'size-3'; // 12px
export const editWidgetIconSizeInRem = 0.75;
export const editWidgetTextSizeClass = 'text-xs'; // 12px
export const editWidgetTextSizeInRem = 0.75;
